export default __webpack_public_path__ + "static/banner_back-2e3adf090e811d3effc2937f58d7672e.webp";